import { BaseElementDefBase, BaseControlDef } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { ExtraDataShimSettings } from "@cs-ts/extra-data-shim-settings";
import { CalculationContext } from "./__CalculationContextInterface";
import { FormControlItem } from "@cs/FormControlItem";

export default class ExtraDataShimDef extends BaseControlDef<ExtraDataShimSettings, FormDefinitionItem<ExtraDataShimSettings>, FormControlItem, string> {
    constructor(parentElement: BaseElementDefBase | null, elementData: FormControlItem, definitionData: FormDefinitionItem<ExtraDataShimSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFExtraDataShim"; // TODO - not hardcoded?
        this.autoEdit = false;
        this.isFocusable = true;
    }

    extraShimValue$() {
        return this.effectiveValueList$();
    }

    effectiveValueList$() {
        return this.valueList$();
    }

    valueList$() {
        return this._maskedValue$();
    }

    effectiveLabelText$() {
        return this._effectiveLabelText$();
    }
}
